/* global BigInt */
// Display estimate only. Promotions and final tax remain owned by the server quote.
export function estimateExtendedLineTaxCents(items, rate) {
	if (!Array.isArray(items) || !Number.isFinite(rate) || rate < 0 || rate > 1) return null;
	const ppm = Math.round(rate * 1000000);
	let total = BigInt(0);
	for (const item of items) {
		const amount = item && item.lineTotalCents;
		if (!Number.isSafeInteger(amount) || amount < 0) return null;
		// Round once per extended line, not per unit or after aggregating the check.
		total += (BigInt(amount) * BigInt(ppm) + BigInt(500000)) / BigInt(1000000);
		if (total > BigInt(Number.MAX_SAFE_INTEGER)) return null;
	}
	return Number(total);
}
